import {zapi} from '../__internal__/http-client/index.js';

import * as endpoints from './endpoints.js';

/**
 * @see https://developer.zattoo.com/display/ZAPI/2.2.4+-+Nonlive+%28Recordings%2C+Replay%29#2.2.4-Nonlive%28Recordings%2CReplay%29-v2getplaylist
 * @returns {Promise<$ZAPI.NPVR.PlaylistResponse>}
 */
export const getNPVRPlaylist = () => zapi({
    path: 'v2/playlist',
    method: 'get',
    endpointID: endpoints.NPVR_PLAYLIST_RECEIVED,
});

/**
 * @see https://developer.zattoo.com/display/ZAPI/2.2.4+-+Nonlive+%28Recordings%2C+Replay%29#2.2.4-Nonlive%28Recordings%2CReplay%29-playlistprogram
 * @param {$ZAPI.NPVR.AddProgramRecordingRequest} data
 * @returns {Promise<$ZAPI.NPVR.RecordingResponse>}
 */
export const addNPVRRecording = (data) => zapi({
    path: 'playlist/program',
    method: 'post',
    endpointID: endpoints.NPVR_RECORDING_ADDED,
    data,
});

/**
 * @see https://developer.zattoo.com/display/ZAPI/2.2.4+-+Nonlive+%28Recordings%2C+Replay%29#2.2.4-Nonlive%28Recordings%2CReplay%29-startseriesrecording
 * @param {$ZAPI.NPVR.StartTVSeriesRecordingRequest} data
 * @returns {Promise<$ZAPI.NPVR.StartTVSeriesRecordingResponse>}
 */
export const startNPVRTVSeriesRecording = (data) => zapi({
    path: 'series_recording/start',
    method: 'post',
    endpointID: endpoints.NPVR_STARTED_SERIES_RECORDING,
    data,
});

/**
 * @see https://developer.zattoo.com/display/ZAPI/2.2.4+-+Nonlive+%28Recordings%2C+Replay%29#2.2.4-Nonlive%28Recordings%2CReplay%29-updaterecording
 * @param {$ZAPI.NPVR.UpdateRecordingRequest} data
 * @returns {Promise<$ZAPI.NPVR.RecordingResponse>}
 */
export const updateNPVRRecording = (data) => zapi({
    path: 'playlist/recording',
    method: 'post',
    endpointID: endpoints.NPVR_RECORDING_UPDATED,
    data: {
        ...data,
        position: new Date(data.position * 1000).toISOString(),
    },
});

/**
 * @see https://developer.zattoo.com/display/ZAPI/2.2.4+-+Nonlive+%28Recordings%2C+Replay%29#2.2.4-Nonlive%28Recordings%2CReplay%29-remplaylist
 * @param {$ZAPI.NPVR.RemoveRecordingRequest} data
 * @returns {Promise<$ZAPI.NPVR.PlaylistDurationResponse>}
 */
export const removeNPVRRecording = (data) => zapi({
    path: 'playlist/remove',
    method: 'post',
    endpointID: endpoints.NPVR_RECORDING_REMOVED,
    data,
});

/**
 * @param {$ZAPI.NPVR.RemoveAllRecordingsRequest | $ZAPI.NPVR.RemoveSelectiveRecordingsRequest} data
 * @returns {Promise<$ZAPI.NPVR.RecordingsIDResponse>}
 */
const removeRecordings = ({filters, ...restData}) => zapi({
    path: 'playlist/batch_remove',
    method: 'post',
    endpointID: endpoints.NPVR_BATCH_RECORDING_REMOVED,
    data: {
        ...restData,
        ...filters,
    },
});

/**
 * @param {$ZAPI.NPVR.RemoveAllRecordingsRequest} data
 * @returns {Promise<$ZAPI.NPVR.RecordingsIDResponse>}
 */
export const removeAllRecordings = (data) => removeRecordings(data);

/**
 * @param {$ZAPI.NPVR.RemoveSelectiveRecordingsRequest} data
 * @returns {Promise<$ZAPI.NPVR.RecordingsIDResponse>}
 */
export const removeSelectiveRecordings = (data) => removeRecordings(data);

/**
 * @see https://developer.zattoo.com/display/ZAPI/2.2.4+-+Nonlive+%28Recordings%2C+Replay%29#2.2.4-Nonlive%28Recordings%2CReplay%29-undeleterecording
 * @param {$ZAPI.NPVR.RestoreRecordingRequest} data
 * @returns {Promise<$ZAPI.NPVR.RecordingResponse>}
 */
export const restoreNPVRRecording = (data) => zapi({
    path: 'playlist/recording/undelete',
    method: 'post',
    endpointID: endpoints.NPVR_RECORDING_RESTORED,
    data,
});

/**
 * @see https://developer.zattoo.com/display/ZAPI/2.2.4+-+Nonlive+%28Recordings%2C+Replay%29#2.2.4-Nonlive%28Recordings%2CReplay%29-stopseriesrecording
 * @param {$ZAPI.NPVR.StopSeriesRecordingRequest} data
 * @returns {Promise<$ZAPI.NPVR.StopSeriesRecordingResponse>}
 */
export const stopNPVRSeriesRecording = (data) => zapi({
    path: 'series_recording/remove',
    method: 'post',
    endpointID: endpoints.NPVR_STOPPED_SERIES_RECORDING,
    data,
});

/**
 * @see https://developer.zattoo.com/display/ZAPI/2.2.4+-+Nonlive+%28Recordings%2C+Replay%29#2.2.4-Nonlive%28Recordings%2CReplay%29-stopseriesrecording
 * @param {$ZAPI.NPVR.StopTVSeriesRecordingRequest} data
 * @returns {Promise<$ZAPI.NPVR.StopSeriesRecordingResponse>}
 */
export const stopNPVRTVSeriesRecording = (data) => zapi({
    path: 'series_recording/remove',
    method: 'post',
    endpointID: endpoints.NPVR_STOPPED_SERIES_RECORDING,
    data,
});
